module.exports = __webpack_public_path__ + "img/DE00760.e0e5b60f.png";